import {CommonModule} from '@angular/common';

import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {SortablejsModule} from "angular-sortablejs";

import {PeriodComponent} from 'app/views/period/period.component';
import {CacheDateComponent} from "app/views/cache_date/cache_date.component";
import {FilterFormComponent} from "app/views/filter_form/filter_form.component";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {ConfirmComponent} from 'app/views/modal/confirm.component';
import {AlertComponent} from 'app/views/modal/alert.component';
import {PromptComponent} from "app/views/modal/prompt.component";
import {ModalContentComponent} from "app/views/modal/modal.component";
import {LoadingComponent} from "./loading.component";
import {LoadingPercentComponent} from "./loading_percent.component";
import {CacheDateService} from "app/views/cache_date/cache_date.service";
import {
	ChartComponent,
	ChartFilterComponent
} from "app/views/chart/chart.component";

import {TRANSLATION_PROVIDERS, TranslatePipe, TranslateService} from 'app/translate';

import {OrderByPipe} from "app/pipes/orderBy.pipe";
import { DateDiff, DateFormat, DateTimeFormat } from 'app/pipes/dateFormat.pipe';

import {KeysPipe} from "app/pipes/keys.pipe";
import {TruncatePipe} from "app/pipes/truncate.pipe";
import {YesNoPipe} from "app/pipes/yesno.pipe";
import {RefComponent} from "./referers/ref.component";
import {RefDetailComponent} from "./referers/ref_detail.component";
import {RefService} from "./referers/ref.service";
import {RegDayRefComponent} from "../user/reg_day/refs/ref.component";
import {DomainBillingRefComponent} from "../domains/domain_billing/refs/ref.component";
import {BillingRefComponent} from "../billing/billing/refs/ref.component";
import {BaseModalComponent, ModalService} from "./modal/base_modal.component";
import {PaidDetailsComponent} from "./modal/paid_details/paid_details.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {InfoModalComponent} from "./modal/info_modal.component";

import {CurrencyLabel} from "app/directives/currency-label.directive";
import {DatetimepickerComponent} from "./datetimepicker/datetimepicker.component";
import {DatepickerComponent} from "./datepicker/datepicker.component";
import {RefStatusComponent} from "./ref_status/ref_status.component";
import { ButtonAnhoreComponent } from "./button/button_anhore";
import { AccordionComponent } from "./accordion.component";
import {SextantDirective} from "../directives/sextant.directive";
import {ExtLinksDirective} from "../directives/ext-links.directive";

import {NgSelectizeModule} from 'ng-selectize';

import {NoAccessComponent} from "../noaccess/noaccess.component";
import {NotFoundComponent} from "../notfound/notfound.component";
import {PrettyNumberPipe} from "../pipes/pretty-number.pipe";
import { ChartSwitchData } from "../pipes/chart-switch-data";
import { FilterByPipe } from "../pipes/filterBy.pipe";
import {NumberFormat} from '../pipes/number-format';
import {ZeroColumnsDirective} from "../directives/zerocolumns.directive";
import {ReporQueriesModalComponent} from "./filter_form/report_queries.component";
import {SourceSelectorComponent} from "app/views/source_selector/source_selector.component";
import {FormErrorIndicatorDirective} from "../directives/form-field-error.directive";
import {FormControlASyncValidators} from "../models/validators/validator";
import {PeriodService} from "./period/period.service";
import { RouterModule } from '@angular/router';
import { PhoneFormat } from "../pipes/phoneFormat";
import {GoToSupportComponent} from "./gotosupport/gotosupport.component";
import {SiteInfoComponent} from "./site_info/site_info.component";
import {SiteInfoService} from "./site_info/site_info.service";


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SortablejsModule,
		NgbModule,
		NgSelectizeModule,
		RouterModule,
	],
	declarations: [
		PeriodComponent,
		CacheDateComponent,
		FilterFormComponent,
		ConfirmComponent,
		AlertComponent,
		PromptComponent,
		ModalContentComponent,
		TranslatePipe,
		OrderByPipe,
		TruncatePipe,
		KeysPipe,
		YesNoPipe,
		DateFormat,
		PrettyNumberPipe,
		LoadingComponent,
		LoadingPercentComponent,
		ChartComponent,
		RefComponent,
		RefDetailComponent,
		RegDayRefComponent,
		BillingRefComponent,
		DomainBillingRefComponent,
		ChartFilterComponent,
		BaseModalComponent,
		InfoModalComponent,
		CurrencyLabel,
		PaidDetailsComponent,
		DatetimepickerComponent,
		DatepickerComponent,
		RefStatusComponent,
		ButtonAnhoreComponent,
		AccordionComponent,
		SextantDirective,
		NoAccessComponent,
		NotFoundComponent,
		ExtLinksDirective,
		ZeroColumnsDirective,
		ChartSwitchData,
		FilterByPipe,
		NumberFormat,
		ReporQueriesModalComponent,
		SourceSelectorComponent,
		FormErrorIndicatorDirective,
		DateTimeFormat,
		DateDiff,
		PhoneFormat,
		GoToSupportComponent,
		SiteInfoComponent,
	],
	providers: [
		FilterFormService,
		CacheDateService,
		TRANSLATION_PROVIDERS,
		TranslateService,
		RefService,
		ModalService,
		FormControlASyncValidators,
		PeriodService,
		SiteInfoService
	],
	exports: [
		PeriodComponent,
		CacheDateComponent,
		FilterFormComponent,
		ConfirmComponent,
		AlertComponent,
		PromptComponent,
		ModalContentComponent,
		TranslatePipe,
		OrderByPipe,
		TruncatePipe,
		KeysPipe,
		YesNoPipe,
		DateFormat,
		CommonModule,
		FormsModule,
		SortablejsModule,
		RefComponent,
		RefDetailComponent,
		RegDayRefComponent,
		BillingRefComponent,
		DomainBillingRefComponent,
		ChartComponent,
		LoadingComponent,
		LoadingPercentComponent,
		ChartFilterComponent,
		BaseModalComponent,
		InfoModalComponent,
		NgbModule,
		CurrencyLabel,
		DatetimepickerComponent,
		DatepickerComponent,
		RefStatusComponent,
		ButtonAnhoreComponent,
		AccordionComponent,
		SextantDirective,
		NgSelectizeModule,
		ExtLinksDirective,
		ZeroColumnsDirective,
		PrettyNumberPipe,
		ChartSwitchData,
		FilterByPipe,
		NumberFormat,
		SourceSelectorComponent,
		FormErrorIndicatorDirective,
		DateTimeFormat,
		DateDiff,
		PhoneFormat,
		GoToSupportComponent,
		SiteInfoComponent,
	],
	entryComponents: [
		RefDetailComponent,
		AlertComponent,
		ConfirmComponent,
		PromptComponent,
		PaidDetailsComponent,
		ReporQueriesModalComponent
	]
})
export class ViewModule {
}
